module.exports = __webpack_public_path__ + "static/favicon_cupis-4a77bfaea7c0cf1b0b4ecb7795ef58d2.ico";